import React from "react";
import { Type } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { FIVE_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createSubject, createSubjectVersion, getSubjects, updateSubjectMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-009: Subject Lines authoring. SUB-SPEC-001's canonical_subject
// is preserved exactly as typed -- no punctuation/Unicode normalization
// happens anywhere in this component or the API client it calls.
const config = {
  familyCode: "SUB",
  testIdPrefix: "subjects",
  idField: "subject_id",
  contentField: "canonical_subject",
  contentLabel: "Canonical Subject",
  contentInputType: "text",
  contentPlaceholder: "e.g. $100,000 in Coverage From $9/Month",
  labelSingular: "Subject Line",
  labelPlural: "Subject Lines",
  icon: Type,
  statusValues: FIVE_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable email subject line (SUB####).",
  api: {
    list: getSubjects,
    create: ({ name, status, content }) => createSubject({ name, status, canonicalSubject: content }),
    createVersion: (id, { version, content }) => createSubjectVersion(id, { version, canonicalSubject: content }),
    updateMetadata: (id, { name, status }) => updateSubjectMetadata(id, { name, status }),
  },
};

export default function SubjectsPanel() {
  return <AssetFamilyPanel config={config} />;
}
